import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

class Item extends PureComponent {
  handleClick = () => {
    const { post, onClick } = this.props;
    if (post && post.id) {
      onClick(post.id);
    }
  };

  render() {
    const { classes, post } = this.props;
    let path = post.path;
    if(path && path !== '/') {
      path = `/${post.path}/${post.slug}`;
    } else {
      path = `/${post.slug}`;
    }
    return (
      <Link
        to={path}
        className={classes.item}
        onClick={this.handleClick}
      >
        <ChevronRightIcon className={classes.icon} />
        {post.title.rendered}
        <em className={classes.time}>{` (${post.shortDate})`}</em>
      </Link>
    );
  }
}

Item.defaultProps = {
  onClick: () => {},
};

Item.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  post: PropTypes.instanceOf(Object).isRequired,
  onClick: PropTypes.func,
};

export default Item;
